module.exports = __webpack_public_path__ + "img/cover.91fde996.jpg";